import InputLabelWrapper from './InputLabelWrapper';
export default InputLabelWrapper;
